export default __webpack_public_path__ + "c12c684db56fbd1638c0649a17947a13.jpg";